import React from 'react';

const Card = ({ title, value, sub, accent, children, className = '' }) => {
  const accentClass = accent === 'yellow' ? 'card-yellow' : accent === 'green' ? 'card-green' : '';
  return (
    <div className={`card ${accentClass} ${className}`}>
      {title && <div className="card-title">{title}</div>}
      {value !== undefined && (
        <div className={`card-value ${accent === 'green' ? 'green' : accent === 'yellow' ? 'yellow' : ''}`}>
          {value}
        </div>
      )}
      {sub && <div className="card-sub">{sub}</div>}
      {children}
    </div>
  );
};

export default Card;
